<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { useCustomerStore } from '@stores/me/customer'

import { useBtnSupport } from '@composables/widgets/menu/btn-support.hook'

import { HOME_TOUR_STEPS } from '@config/feature-tour/home-product-onboarding'

import HeaderNavItem from '@Molecules/HeaderNavItem.vue'
import DropdownSupport from '@Widgets/Menu/DropdownSupport.vue'
import FeatureTourSpot from '@Molecules/FeatureTour/FeatureTourSpot.vue'

defineOptions({
  name: 'BtnSupport',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const customerStore = useCustomerStore()

const { disabled } = useBtnSupport({ customerStore })
</script>

<template>
  <FeatureTourSpot
    v-if="customerStore.isTypePaid"
    :id="HOME_TOUR_STEPS.BTN_SUPPORT"
  >
    <HeaderNavItem
      :layout="layout"
      :icon="layout === 'vertical' ? 'message' : 'comments'"
      label="Support"
      :disabled="disabled"
    >
      <template #menu>
        <DropdownSupport />
      </template>
    </HeaderNavItem>
  </FeatureTourSpot>
</template>
